<template>
    <div class="animated fadeIn">
        <filters :scope="filtersScope">
        </filters>
      <ringing-tabs/>


        <form  id="formCall"  @submit="checkForm">
            <div class="card">
                <div class="card-block">
                    <div class="row">
                        <div class="col-md-3">
                            <table class="table">
                                <tbody>
                                <tr>
                                    <td class="cel"><strong>Тариф смс: </strong> <input type="number" v-model="sms"></td>
                                    <td class="cel"><strong>Стоимость 1 минуты: </strong><input type="number" v-model="call"> </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-md-3"></div>
                        <div class="col-md-3"></div>
                        <div class="col-md-3">
                            <div class="row">
                                <div class="col-md-6"></div>
                                <div class="col-md-6 apply-buttons">
                                    <button class="btn btn-success btn-lg">
                                        <i class="fa fa-check-circle"></i>
                                        Сохранить
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <StatisticTable :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        :columns="columns"
                        :title="`${$t('pages.ringing_sms')}`">
        </StatisticTable>
    </div>
</template>

<script>
    import Filters from '../../../../components/Filters.vue'
    import StatisticTable from '../../../../components/StatisticTable'
    import API from '../../../../api/API'
    import { map } from 'lodash'
    import TypeColor from '../../../../assets/TypeColor'
    import Storage from '../../../../api/Storage'
    import RingingTabs from './RingingTabs'
    import Helper from '../../../../api/Helper'

export default {
      components: {
        RingingTabs,
        Filters,
        StatisticTable
      },
      data () {
        return {
          sms: 0,
          call: 0,
          TypeColor,
          isLoading: false,
          filtersScope: {
            countryFilter: true,
            dateFilter: true,
            offerFilter: true,
            courierFilter: true,
            oneCountryFilter: true,
            byWmFilterAll: true

          },
          headColumns: [
                {label: this.$root.$t('statistic.date'), field: 'date', width: '120px'},
                {label: this.$root.$t('statistic.approve_percent'), field: 'approve_percent'},
                {label: this.$root.$t('statistic.total_sms_sent'), field: 'total_sms_sent'},
                {label: this.$root.$t('statistic.total_all'), field: 'total_all'},
                {label: this.$root.$t('statistic.total_lead_sms_sent'), field: 'total_lead_sms_sent'},
                {label: this.$root.$t('statistic.total_sms'), field: 'total_sms'},
                {label: this.$root.$t('statistic.total_minutes'), field: 'total_minutes'},
                {label: this.$root.$t('statistic.total_all_minutes'), field: 'total_all_minutes'},
                {label: this.$root.$t('statistic.total_minutes_lead'), field: 'total_minutes_lead'},
                {label: this.$root.$t('statistic.total_lead'), field: 'total_lead'},
                {label: this.$root.$t('statistic.total_seconds_call'), field: 'total_seconds_call'},
                {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px'}
          ],
          footColumns: {},
          rows: [],
          columns: null
        }
      },
      mounted () {
        this.calculateRows()
        this.$root.$on('filters_load_new_data', () => {
          this.calculateRows()
        })
      },
      methods: {
        checkForm (e) {
          e.preventDefault()
          let rate = {
            sms: this.sms,
            call: this.call
          }
          API.postRingingRates(rate).then(response => {
            if (response.status === 200) {
              this.calculateRows()
            }
          }).catch(error => {
            console.log('Ошибка в запросе', error)
          })
        },
        calculateRows () {
          this.$root.$emit('data_loading')
          this.rows = []
          this.footColumns = {}
          API.getRingingRates().then(response => {
            this.sms = response.data.sms
            this.call = response.data.call
          })
          let totalApproved = 0
          let totalSmsSent = 0
          API.getRingingSms().then(response => {
            map(response.data, (d) => {
              totalSmsSent += parseInt(d.count_sms)
              this.rows.push({
                date: {
                  value: d.date,
                  bg: true
                },
                approve_percent: {
                  value: `${(parseInt(d.approved).toFixed(0))}`,
                  bg: true
                },
                total_sms_sent: {
                  value: d.count_sms,
                  bg: true
                },
                total_all: {
                  value: d.sms_cost_sum,
                  bg: true
                },
                total_lead_sms_sent: {
                  value: d.sms_per_lead,
                  bg: true
                },
                total_sms: {
                  value: d.cost_per_sms,
                  bg: true
                },
                total_minutes: {
                  value: !d.call_time_minutes ? d.call_time_minutes = 0 : d.call_time_minutes
                },
                total_all_minutes: {
                  value: d.call_cost_sum,
                  bg: true
                },
                total_minutes_lead: {
                  value: d.call_per_lead,
                  bg: true
                },
                total_lead: {
                  value: d.cost_per_call,
                  bg: true
                },
                total_seconds_call: {
                  value: (d.sum_cost_per_lead).toFixed(2),
                  bg: true
                },
                approvedFromValid: {
                  value: Helper.approvedFromValid(parseInt(d.approved), parseInt(d.total), parseInt(d.spam))
                }
              })
            })
            this.$root.$emit('data_loaded')
          }).catch(response => {
            this.$root.$emit('data_loaded')
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: !response.body.message ? response.body : response.body.message,
              animationType: 'velocity'
            })
          })
        }
      }
    }
</script>

<style scoped>
    input {
        outline: none;
        border: none;
        border-bottom: 1px solid #cfd8dc;
    }
</style>



// WEBPACK FOOTER //
// RingingSms.vue?322bcf36